//import api from '../../../../services/api';
import axios from 'axios';
import { currentHttpOptions } from '../../../utils';

const API_URL = '/api/v1/admin/ruleSets';
/**
 * @returns {Promise<ApiAdmin.GetAllRuleSetsResponse>}
 */
export const getAllRuleSet = () => {
    return axios.get(process.env.REACT_APP_API_DOTNET + API_URL,
        currentHttpOptions())
}

/**
 * @returns {Promise<ApiAdmin.GetAllRuleSetsResponse>}
 */
export const getAllCustomFormat = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/CustomDateFormat`,
    currentHttpOptions())
}

/**
 * @returns {Promise<ApiAdmin.GetAllCustomDataFieldsResponse>}
 */
 export const getAllCustomDataFields = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/CustomDataFields`,
    currentHttpOptions())
}

/**
 * @param {number} rulesetId
 * @returns {Promise<ApiAdmin.GetRuleSetDetailsResponse>}
 */
 export const getRuleSet = (rulesetId) => axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/${rulesetId}`, currentHttpOptions());

/**
 * @param {RuleSet.IRuleSetDetails} ruleSet
 * @returns {Promise<ApiAdmin.GetRuleSetDetailsResponse>}
 */
export const createRuleSet = (ruleSet) => axios.post(`${process.env.REACT_APP_API_DOTNET}${API_URL}`, ruleSet, currentHttpOptions());

/**
 * @param {number} rulesetId
 * @param {RuleSet.IRuleSetDetails} ruleSet
 * @returns {Promise<ApiAdmin.GetRuleSetDetailsResponse>}
*/
 // eslint-disable-next-line max-len
 export const updateRuleSet = (rulesetId, ruleSet) => axios.put(`${process.env.REACT_APP_API_DOTNET}${API_URL}/${rulesetId}`, ruleSet, currentHttpOptions());
 
/**
 * @param {number} rulesetId
 * @returns {Promise<import('axios').AxiosResponse<any>>}
*/
 export const deleteRuleSet = (rulesetId) => axios.delete(`${process.env.REACT_APP_API_DOTNET}${API_URL}/${rulesetId}`, currentHttpOptions());
